import React from "react";
import { useTranslation } from "react-i18next";

import { SECTION_IDS } from "@constants/sectionIds";

import "./FinderPromo .scss";

const FinderPromo = () => {
  const { t } = useTranslation("landing");

  return (
    <section id={SECTION_IDS.FINDER_PROMO} className="finder-promo">
      <div className="finder-promo__main">
        <h2>{t("finderPromo.title")}</h2>
        <p className="p0">{t("finderPromo.description")}</p>
      </div>

      <div className="finder-promo__app-preview">
        <div className="app-preview">
          <img
            aria-hidden="true"
            src="/images/layouts/about-us/app-preview-blur-left.png"
            alt=""
            width={362}
            height={530}
            className="app-preview-blur app-preview-blur--left"
          />

          <img
            aria-hidden="true"
            src="/images/layouts/about-us/app-preview-blur-right.png"
            alt=""
            width={475}
            height={700}
            className="app-preview-blur app-preview-blur--right"
          />

          <img
            src="/images/layouts/about-us/app-preview.png"
            alt={t("finderPromo.appPreviewImage.alt")}
            width={460}
            height={320}
            className="app-preview-img"
          />
        </div>

        <img
          aria-hidden="true"
          src="/images/layouts/finder-lines-1.svg"
          alt=""
          width={2348}
          height={746}
          className="lines-bg-mobile"
        />
      </div>
    </section>
  );
};

export default FinderPromo;
